import useSWRMutation, { type SWRMutationConfiguration } from 'swr/mutation';
import denApi from '@/lib/api/denApi';

type DeleteInviteArg = {
  email: string;
};

type DeleteInviteResponse = {
  success: true;
};

const fetcher = async (
  _key: string,
  { arg }: { arg: DeleteInviteArg }
): Promise<DeleteInviteResponse> => {
  return await denApi.post<DeleteInviteResponse, DeleteInviteArg>(
    'admin/organization/invitations/delete',
    arg
  );
};

export function useDeleteInvite(
  swrOptions?: SWRMutationConfiguration<
    DeleteInviteResponse,
    Error,
    string,
    DeleteInviteArg
  >
) {
  const { trigger, isMutating, error } = useSWRMutation<
    DeleteInviteResponse,
    Error,
    string,
    DeleteInviteArg
  >('admin/organization/invitations/delete', fetcher, swrOptions);

  return {
    deleteInvite: trigger,
    isDeleting: isMutating,
    error,
  };
}
